import Badge from "components/v2/Badge/Badge";
import { Accordion, Card } from "react-bootstrap";
import { ReactComponent as ChevronUp } from "assets/images/iconsV2/chevron-up.svg";
import { ReactComponent as ChevronDown } from "assets/images/iconsV2/chevron-down.svg";
import { ReactComponent as ArrowNarrowRight } from "assets/images/iconsV2/arrow-narrow-right.svg";

import "./AccordionHeader.scss";

interface AccordionHeaderProps {
  pickup: string;
  delivery: string;
  totalOrderCount: string;
  children: React.ReactNode;
  orderId: string;
  setActiveAccordion: (orderId: string) => void;
  activeAccordion: string;
  selectedOrders: any;
}

function AccordionHeader({
  orderId,
  pickup,
  delivery,
  totalOrderCount,
  children,
  selectedOrders,
  setActiveAccordion,
  activeAccordion,
}: AccordionHeaderProps) {
  const handleToggle = () => {
    if (activeAccordion === orderId) setActiveAccordion("");
    else setActiveAccordion(orderId);
  };

  return (
    <div className="consolidated-accordion-header">
      <Accordion.Toggle as={Card.Header} onClick={handleToggle} eventKey={orderId}>
        <div
          className="text-sm text-secondary-v2"
          style={{ display: "flex", alignItems: "center", cursor: "pointer", width: "100%" }}
        >
          <div className="mr-xl">{activeAccordion === orderId ? <ChevronUp /> : <ChevronDown />}</div>

          <span className="consolidated-accordion-header__location">{pickup}</span>

          <span className="d-flex align-items-center">
            <ArrowNarrowRight className="mr-xl ml-xl" />
            <div className="consolidated-accordion-header__location">{delivery}</div>
          </span>

          <div className="consolidated-accordion-header__badge">
            {selectedOrders.length > 0 && selectedOrders[0].parentId === orderId ? (
              <Badge
                label={`${selectedOrders.length} out of ${totalOrderCount} selected`}
                color="brand"
                type="category-badge"
              />
            ) : (
              <Badge label={totalOrderCount} color="gray" type="category-badge" />
            )}
          </div>
        </div>
        <Accordion.Collapse eventKey={orderId}>
          <div style={{ width: "100%" }}>{children}</div>
        </Accordion.Collapse>
      </Accordion.Toggle>
    </div>
  );
}

export default AccordionHeader;
